import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResponsdoctorsParaMedicspecialty extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  responsdoctorsParaMedicspecialtyState: this.props.responsdoctorsParaMedicspecialty,
                  selectedResponsdoctorsParaMedicspecialty: {
                        value: this.props.responsdoctorsParaMedicspecialty.responsdoctors_price_paramedic_responsdoctors_paramedic_id,
                        label: this.props.responsdoctorsParaMedicspecialty.responsdoctors_paramedicspecialty_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionResponsdoctorsParaMedicspecialty: [],
            }
      }
      componentDidMount() {
            this.getoptionResponsdoctorsParaMedicspecialty()
      }

      getoptionResponsdoctorsParaMedicspecialty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].groupـofـdoctors_id,
                                          label: arr.data[k].groupـofـdoctors_name,
                                    })
                              }
                              self.setState({ optionResponsdoctorsParaMedicspecialty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_groupـofـdoctors")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedResponsdoctorsParaMedicspecialty) => {
            var temparray = this.state.responsdoctorsParaMedicspecialtyState
            temparray.responsdoctors_price_paramedic_responsdoctors_paramedic_id = selectedResponsdoctorsParaMedicspecialty.value
            this.setState({
                  selectedResponsdoctorsParaMedicspecialty: selectedResponsdoctorsParaMedicspecialty,
                  responsdoctorsParaMedicspecialtyState: temparray,
            })
      }

      handleChangeParaMedicPrice = (event) => {
            var temparray = this.state.responsdoctorsParaMedicspecialtyState
            temparray.responsdoctors_price_paramedic_price = event
            this.setState({ responsdoctorsParaMedicspecialtyState: temparray })
      }

      handleChangeParaMedicResident = (event) => {
            var temparray = this.state.responsdoctorsParaMedicspecialtyState
            temparray.responsdoctors_price_paramedic_student = event
            this.setState({ responsdoctorsParaMedicspecialtyState: temparray })
      }

      handleChangeParaMedicDiscount = (event) => {
            var temparray = this.state.responsdoctorsParaMedicspecialtyState
            temparray.responsdoctors_price_paramedic_discount = event
            this.setState({ responsdoctorsParaMedicspecialtyState: temparray })
      }

      handleChangeParaMedicAditionalcovarage = (event) => {
            var temparray = this.state.responsdoctorsParaMedicspecialtyState
            temparray.responsdoctors_price_paramedic_aditionalcovarage = event
            this.setState({ responsdoctorsParaMedicspecialtyState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { responsdoctorsParaMedicspecialtyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_paramedic_tb")
            fd.append("responsdoctors_price_paramedic_id", responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_id)
            fd.append("responsdoctors_price_paramedic_price", responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_price)
            fd.append("responsdoctors_price_paramedic_student", responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_student)
            fd.append("responsdoctors_price_paramedic_discount", responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_discount)
            fd.append(
                  "responsdoctors_price_paramedic_aditionalcovarage",
                  responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_aditionalcovarage
            )

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { responsdoctorsParaMedicspecialtyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_paramedic_tb")
            fd.append("responsdoctors_price_paramedic_id", responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_id)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResponsdoctorsParaMedicspecialty,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResponsdoctorsParaMedicspecialty,
                  responsdoctorsParaMedicspecialtyState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={2}>
                                    <div>
                                          <label className="on">تخصص پیراپزشک </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"تخصص پیراپزشک"}
                                                value={selectedResponsdoctorsParaMedicspecialty}
                                                onChange={this.handleInstalmentMode}
                                                options={optionResponsdoctorsParaMedicspecialty}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت پایه پیراپزشک"
                                          handleInputt={this.handleChangeParaMedicPrice}
                                          value={responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_price}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت اضافی دانشجو"
                                          handleInputt={this.handleChangeParaMedicResident}
                                          value={responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_student}
                                    />
                              </Grid>
                              <Grid item item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="پوشش اضافی دیه"
                                          handleInputt={this.handleChangeParaMedicAditionalcovarage}
                                          value={responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_aditionalcovarage}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد تخفیف"
                                        handleInputt={this.handleChangeParaMedicDiscount}
                                        value={responsdoctorsParaMedicspecialtyState.responsdoctors_price_paramedic_discount}
                                    />
                              </Grid>

                              <Grid item xs={1}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResponsdoctorsParaMedicspecialty)
